import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../../core';
import { ClienteCentralCompra } from '../cliente-central-compra';
import { ClienteCentralCompraHttpService } from '../services';
import { ClienteCentralCompraParticipanteFormComponent } from '../participante';

@Component({
    selector: 'sgt-cliente-central-compra-form',
    templateUrl: './cliente-central-compra-form.component.html',
    styleUrls: ['./cliente-central-compra-form.component.less']
})
export class ClienteCentralCompraFormComponent {
    isLoading: boolean;
    isLoaded: boolean;
    centralCompras: ClienteCentralCompra;

    @ViewChild('form') form: NgForm;
    @ViewChild('formParticipantes') formParticipantes: ClienteCentralCompraParticipanteFormComponent;

    constructor(private messageService: MessageService,
                private clienteCentralCompraHttpService: ClienteCentralCompraHttpService) { }

    /** Edita a central de compras informada */
    edit(id: number) {
        this.load(id);
    }

    /** Carrega a central de compras */
    private load(id: number) {
        this.centralCompras = null;
        this.isLoading = true;
        this.isLoaded = false;
        this.clienteCentralCompraHttpService.load(id)
            .pipe(
                take(1)
            )
            .subscribe(
                centralCompras => {
                    this.centralCompras = centralCompras;
                    this.isLoading = false;
                    this.isLoaded = true;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar a central de compras', error);
                    this.centralCompras = null;
                    this.isLoading = false;
                    this.isLoaded = true;
                }
            );
    }

    /** Valida se as informações estão corretas para pode salvar */
    private isValid(): boolean {
        // Validando os participantes
        if (!this.formParticipantes?.isValid()) {
            return false;
        }

        return true;
    }

    /** Salva a central de compras */
    save(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            if (!this.isValid()) {
                reject();
                return;
            }

            this.clienteCentralCompraHttpService.save(this.centralCompras)
                .subscribe(
                        () => {
                            this.messageService.success('', 'Central de Compras salva com sucesso');
                            resolve();
                        },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao salvar a central de compras', error);
                        reject(error);
                    }
                )
        });
    }

    /** Limpa as variáveis do form */
    clear() {
        this.centralCompras = null;
    }
}
